import { render, staticRenderFns } from "./FAQSWC.vue?vue&type=template&id=a6d6c4f0&scoped=true"
import script from "./FAQSWC.vue?vue&type=script&lang=js"
export * from "./FAQSWC.vue?vue&type=script&lang=js"
import style0 from "./FAQSWC.vue?vue&type=style&index=0&id=a6d6c4f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d6c4f0",
  null
  
)

export default component.exports